import React, { useContext, useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Link, useNavigate } from "react-router-dom";
import CountUp from "react-countup";
import { Calendar } from "primereact/calendar";
import { Nullable } from "primereact/ts-helpers";
import "bootstrap-daterangepicker/daterangepicker.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Cookies from "js-cookie";
import { BiRefresh } from "react-icons/bi";
import { motion, Variants } from "framer-motion";
import { Offcanvas } from "bootstrap";
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import LogoSpinnerInline from "../../../academic/examinations/spinner";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    ResponsiveContainer,
    RadialBarChart,
    RadialBar,
    PolarAngleAxis,
    CartesianGrid,
} from "recharts";
import { format } from "date-fns";
import { DateRange } from "react-date-range";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateLeft, faSearch } from "@fortawesome/free-solid-svg-icons";
import { DatePicker, Select, Spin } from "antd";
import { all_routes } from "../../../router/all_routes";
import { useUserPermissions } from "../../../UserPermissionsContext";
import { InactivityContext } from "../InactivityContext";
import Counter from "../counter";
import AdminDashboardModal from "../../../mainMenu/adminDashboard/adminDashboardModal";
import bootstrap from "bootstrap";
import CommonSelect from "../../../../core/common/commonSelect";
import dayjs, { Dayjs } from "dayjs";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";

type User = {
    id: number;
    username: string;
    no_of_calls: number;
    no_of_calls_connected: number;
    no_of_sales: number;
};

type User1 = {
    branch_id: number;
    branch: string;
    sales: number;
}

type Class = {
    class_id: number;
    class_name: string;
    strength: number;
    last_year_sales_count: number;
    renewal_sales: number;
    new_sales: number;
    total_sales: number;
}

type GroupData = {
    total_sales: number;
    members: User[];
};

type SalesRank = {
    total_sales: number;
    branch_count: number;
    branches: User1[];
};

type ClassWizeSale = {
    branch_id: number;
    branch_name: string;
    class_wise_sales: Class[];
};

export type Option = {
    value: string;
    label: string;
};


const players = [
    {
        name: "Mohan",
        score: 425,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
    {
        name: "Pavan",
        score: 524,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
    {
        name: "Ravi",
        score: 625,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
];
const data135: Record<string, User[]> = {
    "Elite": [
        { id: 5, username: "yathin", no_of_calls: 0, no_of_calls_connected: 0, no_of_sales: 0 },
        { id: 23, username: "srilatha", no_of_calls: 12, no_of_calls_connected: 8, no_of_sales: 0 },
        // ...
    ],
    "Rapid Risers": [
        { id: 26, username: "pavan123", no_of_calls: 0, no_of_calls_connected: 0, no_of_sales: 0 },
        // ...
    ],
    "Challengers": [
        { id: 33, username: "Manikanta", no_of_calls: 0, no_of_calls_connected: 0, no_of_sales: 0 }
    ]
};
const salesData = [
    { name: "Alice", sales: 250, image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png" },
    { name: "Bob", sales: 180, image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png" },
    { name: "Charlie", sales: 300, image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png" },
    { name: "David", sales: 150, image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png" },
    { name: "Eve", sales: 220, image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png" },
];

const top3Agents = [
    {
        agent_id: 41,
        agent_name: "akhila_ms",
        sales_count: 6,
        agent_profile: "/media/pics/user_profile/photos/4e4615a870984277a21ca0244f3e041c.webp",
    },
    {
        agent_id: 9,
        agent_name: "Ganesh",
        sales_count: 5,
        agent_profile: "/media/pics/user_profile/photos/6afea485d1dc45debce76a1b78385b5d.webp",
    },
    {
        agent_id: 18,
        agent_name: "Syed_Marvan_Uddin",
        sales_count: 4,
        agent_profile: "/media/pics/user_profile/photos/2771465366ec41a9b3c0077d7de1da0f.webp",
    },
];

const data = [
    { name: "Mon", Calls: 120, Connected: 80 },
    { name: "Tue", Calls: 180, Connected: 110 },
    { name: "Wed", Calls: 150, Connected: 90 },
    { name: "Thu", Calls: 200, Connected: 140 },
    { name: "Fri", Calls: 170, Connected: 100 },
    { name: "Sat", Calls: 130, Connected: 70 },
];

const leaderboardData = [
    { name: "Amelia Kerr", points: 720, position: 1 },
    { name: "Jess Kerr", points: 720, position: 2 },
    { name: "Eden Carson", points: 720, position: 3 },
];

const data5 = [
    { day: "Mon", sales: 40, connected: 80 },
    { day: "Tue", sales: 90, connected: 140 },
    { day: "Wed", sales: 70, connected: 100 },
    { day: "Thu", sales: 80, connected: 120 },
    { day: "Fri", sales: 50, connected: 90 },
    { day: "Sat", sales: 85, connected: 110 },
];

const dataL = [
    {
        profileImage: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png',
        image: '/assets/img/Vector (1).png',
        name: 'John Doe',
        saleCount: 150
    },
    {
        profileImage: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png',
        image: '/assets/img/Vector.png',
        name: 'Jane Smith',
        saleCount: 200
    },
    {
        profileImage: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png',
        image: '/assets/img/Vector (2).png',

        name: 'Mark Johnson',
        saleCount: 100
    }
];

type Dashboard = {
    id: number;
    agent_name: string;
    status_name: string;
    updated_at: string;
    last_login_time: string;
    agent: number;
    status: number;
    calls: string;
    connected: string;
    missed: string;
    interested: string;
    callbacks: string;
    sale: string;
    performance: string;
    total_ideal_time: string;
    conversation_time: string;
};

const topThree = [
    { name: "Ravi", score: 625, rank: 1 },
    { name: "Mohan", score: 425, rank: 2 },
    { name: "Pavan", score: 524, rank: 3 },
];

// const others = [
//     { name: "Akash", score: 3768 },
//     { name: "Papa Rao", score: 3768 },
//     { name: "Chikitha", score: 3768 },
//     { name: "Anil", score: 3768 },
//     { name: "Doopesh", score: 3768 },
// ];

interface Winner {
    name: string;
    rank: number;
    image: string;
}

const winners = [
    {
        rank: 1,
        name: "John",
        score: 4500,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
    {
        rank: 2,
        name: "Emma",
        score: 4200,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
    {
        rank: 3,
        name: "Liam",
        score: 3900,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
    {
        rank: 4,
        name: "Olivia",
        score: 3768,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
    {
        rank: 5,
        name: "Noah",
        score: 3600,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
    {
        rank: 6,
        name: "Sophia",
        score: 3450,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
    {
        rank: 1,
        name: "John",
        score: 4500,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
    {
        rank: 2,
        name: "Emma",
        score: 4200,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
    {
        rank: 3,
        name: "Liam",
        score: 3900,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
    {
        rank: 4,
        name: "Olivia",
        score: 3768,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
    {
        rank: 5,
        name: "Noah",
        score: 3600,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
    {
        rank: 6,
        name: "Sophia",
        score: 3450,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
];

const barImages = [
    '/assets/img/Vector (1).png', // Bar image 1
    '/assets/img/Vector.png', // Bar image 2
    '/assets/img/Vector (2).png', // Bar image 3
];

const profileImages = [
    'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', // Profile image 1
    'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', // Profile image 2
    'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', // Profile image 3
];

type TodayLeads = {
    total_leads: number;
    call_logs: number;
    connected_call_logs: number;
    interested: number;
    call_backs: number;
    sales: number;
    average_conversation_duration: string;
    "call/leads_per": number;
    calls_connected_per: number;
    interested_per: number;
    call_backs_per: number;
    sales_per: number;
    not_interested: number;
    not_interested_per: number;
    achieved_amount: string;
    target_amount: string;
    target_amount_per: number;
    weekly_sales_target: number;
    weekly_sales_achieved: number;
    weekly_sales_achieved_percentage: number;
    target_conversation_time: any;
    conversation_time: any;
    conversation_efficiency: number;
    total_calls: number;
    connected_calls: number;
    call_connected_per: number;
    unique_leads_touch: number;
    unique_leads_connected: number;
    unique_leads_connected_per: number;
    total_sales: number;
    // sales_per:number;
};

interface SalesData {
    rank: number;
    profilePic: string;
    name: string;
    sales: number;
}

interface Leaderboard {
    rank: number;
    id: number,
    username: string;
    sales_count: number;
    photo: string;
    sl_no: number;
}
interface CallsDaily {
    calls: number;
    connected: number,
    label: string
}

interface Data {
    Daily: SalesData[];
    Weekly: SalesData[];
    Monthly: SalesData[];
    AllTime: SalesData[];
}

const data9: Data = {
    Daily: [
        { rank: 1, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Alice', sales: 10 },
        { rank: 2, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Bob', sales: 8 },
        { rank: 3, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Charlie', sales: 5 },
    ],
    Weekly: [
        { rank: 1, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'David', sales: 50 },
        { rank: 2, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Eve', sales: 45 },
        { rank: 3, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Frank', sales: 30 },
    ],
    Monthly: [
        { rank: 1, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Grace', sales: 200 },
        { rank: 2, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Heidi', sales: 180 },
        { rank: 3, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Ivan', sales: 150 },
    ],
    AllTime: [
        { rank: 1, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Judy', sales: 1000 },
        { rank: 2, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Karl', sales: 950 },
        { rank: 3, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Leo', sales: 900 },
    ],
};

interface SalesDaily {
    label: string,
    sales: number,
}
interface Branch {
    branch_id: number,
    name: string,
    label: string,
}

interface SortConfig {
    field: "sales" | "strength";
    direction: "asc" | "desc";
    secondaryDirection: "asc" | "desc"; // New state to track secondary direction
}

const EmployeeDashboard = () => {
    const routes = all_routes;
    const navigate = useNavigate();
    const [photoLoading, setPhotoLoading] = useState(false);
    const [date, setDate] = useState<Nullable<Date>>(null);
    const { userPermissions, webApi, userData } = useUserPermissions();
    const [dashboardData, setDashboardData] = useState<Dashboard[]>([]);
    const jwtToken = Cookies.get("authToken");
    const context = useContext(InactivityContext);
    const [todayLeads, setTodayLeads] = useState<TodayLeads | null>(null);
    const [top3Wizklub, setTop3Wizlub] = useState<any[]>([]);
    const [overall, setoverall] = useState<any[]>([]);
    const [dateRangeLeads, setDateRangeLeads] = useState<TodayLeads | null>(null);
    const [todayLeadsLoading, setTodayLeadsLoading] = useState(false);
    const [DateRangeLeadsLoading, setDateRangeLeadsLoading] = useState(false);
    const [leaderboard, setLeaderBoard] = useState<Leaderboard[]>([]);
    const [CallsDailyGraph, setCallsDailyGraph] = useState<CallsDaily[]>([])
    const [salesDaily, setSalesDaily] = useState<SalesDaily[]>([]);
    const [groupsData, setGroupsData] = useState<Record<string, GroupData>>({});
    const [SalesRank, setSalesRank] = useState<Record<string, SalesRank>>({});
    const [classWizeSalesReport, setClassWizeSalesReport] = useState<ClassWizeSale | null>(null);
    const [branchesDropdown, setBranchesDropdown] = useState<Branch[]>([]);
    const sortedData = [...salesData].sort((a, b) => b.sales - a.sales);
    const maxSales = Math.max(...salesData.map((s) => s.sales));
    const [refreshIsLoading, seteRfreshIsLoading] = useState(false);
    const [groupsCardLoading, setGroupsCardLoading] = useState(false);
    const [SalesRankLoading, setSalesRankLoading] = useState(false);
    const [classWizeSalesLoading, setClassWizeSalesLoading] = useState(false);
    const [selectedBranch, setSelectedBranch] = useState<Option | null>(null);

    const cardVariants: Variants = {
        hidden: {
            opacity: 0,
            y: 30,
        },
        visible: (index: number) => ({
            opacity: 1,
            y: 0,
            transition: {
                delay: index * 0.1,
                duration: 0.5,
                ease: [0.25, 0.1, 0.25, 1], // ← cubic-bezier (easeOut)
            },
        }),
    };
    const [bgGradient, setBgGradient] = React.useState(
        "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
    );

    const extractColor = (img: HTMLImageElement) => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        if (!ctx) return;

        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        ctx.drawImage(img, 0, 0);

        const { data } = ctx.getImageData(0, 0, canvas.width, canvas.height);

        let r = 0, g = 0, b = 0, count = 0;

        for (let i = 0; i < data.length; i += 4 * 20) {
            r += data[i];
            g += data[i + 1];
            b += data[i + 2];
            count++;
        }

        r = Math.floor(r / count);
        g = Math.floor(g / count);
        b = Math.floor(b / count);

        setBgGradient(
            `linear-gradient(135deg, rgb(${r},${g},${b}) 0%, rgba(${r},${g},${b},0.6) 100%)`
        );
    };
    const [sortConfig, setSortConfig] = useState<SortConfig>({
        field: "sales",
        direction: "desc",
        secondaryDirection: "desc",
    });
    const inactivityContext = useContext(InactivityContext);
    if (!inactivityContext) {
        throw new Error("Header must be used within an InactivityProvider");
    }
    const { photo1 } = inactivityContext;
    //   const { userPermissions, webApi, userData } = useUserPermissions();
    const [branchName, setBranchName] = useState("");
    const today = new Date();

    const [selectedDate, setSelectedDate] = useState<Dayjs>(dayjs());

    const handleBranchChange = async (selected: Option | null) => {
        const branch = branchesDropdown.find(
            (c) => c.branch_id === parseInt(selected?.value || "")
        );
        setSelectedBranch(
            branch
                ? {
                    value: branch.branch_id.toString(),
                    label: branch.name,
                }
                : null
        );
    };




    const [salesVsConnected, setSalesVsConnected] = useState({
        total_sales: 0,
        total_connected: 0,
        sales_vs_connected_per: 0,
        results: [],
    });
    const [salesVsCallBack, setSalesVsCallBack] = useState({
        total_sales: 0,
        total_call_backs: 0,
        sales_vs_call_backs_per: 0,
        results: [],
    });
    const [salesVsIntrested, setSalesVsIntrested] = useState({
        total_sales: 0,
        total_interested: 0,
        sales_vs_interested_per: 0,
        results: [],
    });

    const [activeTab, setActiveTab] = useState<'Daily' | 'Weekly' | 'Monthly' | 'AllTime'>('Daily');
    const checkPermission = (action: any, subject: any) => {
        return userPermissions.some(
            (ability) => ability.action === action && ability.subject === subject
        );
    };

    useEffect(() => {
        setLeaderBoard([]);
        fetchLeaderboard(tabToDays[activeTab])
    }, [activeTab]);

    const tabMapping: { [key: string]: 'Daily' | 'Weekly' | 'Monthly' | 'AllTime' } = {
        'Today': 'Daily',
        'Last 7 days': 'Weekly',
        'Last 30 days': 'Monthly',
        'AllTime': 'AllTime'
    };

    const tabToDays = {
        Daily: "today",
        Weekly: "week",
        Monthly: "month",
        AllTime: "all",
    };


    const top3 = leaderboard.slice(0, 3); // Top 3 agents
    const others = leaderboard.slice(3);
    const reorderedTop3 = [top3[1], top3[0], top3[2]].filter(Boolean);


    if (!context) {
        throw new Error("SomeComponent must be used within an InactivityProvider");
    }

    const { isIdle, isStatusChange, setIsStatusChange } = context;

    const [monitoringStatus, setMonitoringStatus] = useState<
        { id: number; name: string }[]
    >([]);

    const options = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
        },
    };

    const formatDate = (date: Dayjs): string => {
        return date.format("YYYY-MM-DD");
    };

    const fetchData = async () => {
        seteRfreshIsLoading(true); // Set loading to true
        try {
            const dateStr = formatDate(selectedDate);
            const response = await fetch(
                `${webApi}/dashboard/employee_calling_monitoring/`,
                options
            );
            const data = await response.json();
            setDashboardData(data.results);
        } catch (error) {
            console.error("Failed to fetch data:", error);
        } finally {
            seteRfreshIsLoading(false); // Set loading back to false after fetch is complete
        }
    };

    useEffect(() => {
        fetchData();
    }, [selectedDate])

    const fetchLeaderboard = async (days: string) => {
        const response = await fetch(
            `${webApi}/dashboard/wizklub_leader_board/?filter=${days}`,
            options
        );
        const data = await response.json();
        setLeaderBoard(data);
    };


    const fetchCalldDailyGraph = async () => {
        const response = await fetch(
            `${webApi}/dashboard/wizklub_calls_graph/`,
            options
        );
        const data = await response.json();
        setCallsDailyGraph(data);
    };

    const fetchGroupsCard = async (startDate: string, endDate: string): Promise<void> => {
        try {
            setGroupsCardLoading(true);

            const response = await fetch(
                `${webApi}/dashboard/user_wizklub_sales_rank_group/?from_date=${startDate}&to_date=${endDate}`,
                options
            );

            if (!response.ok) {
                throw new Error(`Failed to fetch data: ${response.statusText}`);
            }

            const data = await response.json();
            setGroupsData(data);
        } catch (error) {
            console.error("Error fetching group card data:", error);
        } finally {
            setGroupsCardLoading(false);
        }
    };

    const fetchSalesRank = async () => {
        try {
            setSalesRankLoading(true);
            const { field, direction, secondaryDirection } = sortConfig;
            const secondaryField = field === "sales" ? "strength" : "sales";

            // Primary field with direction, secondary field with its own direction
            const primaryOrdering = direction === "desc" ? `-${field}` : field;
            const secondaryOrdering = secondaryDirection === "desc" ? `-${secondaryField}` : secondaryField;
            const orderingParam = `${primaryOrdering},${secondaryOrdering}`;

            const response = await fetch(
                `${webApi}/branches/wizklub_branch_sales_ranking_for_trainers/?ordering=${orderingParam}`,
                options
            );

            if (!response.ok) throw new Error("Failed to fetch");

            const data = await response.json();

            setSalesRank(data);
        } catch (error) {
            console.error("Fetch error:", error);
        } finally {
            setSalesRankLoading(false);
        }
    };

    const handleSortClick = (clickedField: "sales" | "strength") => {
        setSortConfig((prev) => {
            if (prev.field === clickedField) {
                // Flip direction if same field
                return {
                    ...prev,
                    direction: prev.direction === "asc" ? "desc" : "asc",
                };
            } else {
                // New field - maintain the other field's direction as secondary
                return {
                    field: clickedField,
                    direction: "asc", // Default direction for new primary field
                    secondaryDirection: prev.direction, // Preserve the previous primary direction
                };
            }
        });
    };

    useEffect(() => {
        fetchSalesRank();
    }, [sortConfig]);



    const fetchSalesGraph = async () => {
        const response = await fetch(
            `${webApi}/dashboard/wizklub_trainer_sales_graph_dashboard/`,
            options
        );
        const data = await response.json();
        setSalesDaily(data);
    };

    const fetchSalesVsConnected = async () => {
        const response = await fetch(
            `${webApi}/dashboard/wizklub_sales_vs_connected_call_graph/`,
            options
        );
        const data = await response.json();
        setSalesVsConnected(data);
    };

    const fetchSalesVsCallBacks = async () => {
        const response = await fetch(
            `${webApi}/dashboard/wizklub_sales_vs_call_backs_graph/`,
            options
        );
        const data = await response.json();
        setSalesVsCallBack(data);
    };

    const fetchSalesvsIntrested = async () => {
        const response = await fetch(
            `${webApi}/dashboard/wizklub_sales_vs_interested_graph/`,
            options
        );
        const data = await response.json();
        setSalesVsIntrested(data);
    };

    const fetchMonitoringStatusDropdown = async () => {
        const response = await fetch(
            `${webApi}/user_monitoring/monitoring_status_types_dropdown/`,
            options
        );
        const data = await response.json();
        setMonitoringStatus(data);
    };

    const fetchTop3 = async () => {
        const response = await fetch(
            `${webApi}/dashboard/wizklub_today_top_three_trainer_performers/`,
            options
        );
        const data = await response.json();
        setTop3Wizlub(data);
    };

    const fetchOverall = async () => {
        const response = await fetch(
            `${webApi}/dashboard/wizklub_orverall_top_three_trainer_performers/`,
            options
        );
        const data = await response.json();
        setoverall(data);
    };

    const fetchBranches = async () => {
        const response = await fetch(
            `${webApi}/branches/wizklub_branches_dropdown/`,
            options
        );
        const data = await response.json();
        setBranchesDropdown(data);
    };

    const fetchClassWizeSales = async () => {
        setClassWizeSalesLoading(true); // Start loading
        try {
            // Build URL conditionally
            const url = selectedBranch
                ? `${webApi}/dashboard/branch_class_wise_sales_report/?branch_id=${selectedBranch.value}`
                : `${webApi}/dashboard/branch_class_wise_sales_report/`;

            const response = await fetch(url, options);

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            setBranchName(data.branch_name);
            const matchedBranch = branchesDropdown.find(
                (branch) => branch.branch_id === parseInt(data.branch_id)
            );

            setSelectedBranch(
                matchedBranch
                    ? {
                        value: matchedBranch.branch_id.toString(),
                        label: matchedBranch.name,
                    }
                    : null
            );
            setClassWizeSalesReport(data);

        } catch (error) {
            console.error("Failed to fetch class-wise sales:", error);
            // You can show a toast or set an error state here
        } finally {
            setClassWizeSalesLoading(false); // Stop loading
        }
    };

    const fetchClassWizeSales2 = async () => {
        setClassWizeSalesLoading(true); // Start loading
        try {
            // Build URL conditionally
            const url = selectedBranch
                ? `${webApi}/dashboard/branch_class_wise_sales_report/?branch_id=${selectedBranch.value}`
                : `${webApi}/dashboard/branch_class_wise_sales_report/`;

            const response = await fetch(url, options);

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            setBranchName(data.branch_name);
            setClassWizeSalesReport(data);

        } catch (error) {
            console.error("Failed to fetch class-wise sales:", error);
            // You can show a toast or set an error state here
        } finally {
            setClassWizeSalesLoading(false); // Stop loading
        }
    };

    useEffect(() => {
        fetchClassWizeSales2()
    }, [selectedBranch])


    const branchOptions = branchesDropdown.map(branch => ({
        value: String(branch.branch_id),
        label: branch.label
    }));


    const fetchTodayLeadsData = async () => {
        setTodayLeadsLoading(true);
        try {
            const response = await fetch(
                `${webApi}/dashboard/employee_calling_today_dashboard/`,
                options
            );
            if (!response.ok) {
                const errorData = await response.json();
                if (errorData.code === "token_not_valid") {
                    navigate("/academic/sri-chaitanya/crm/landing-page");
                }
                throw new Error(errorData.detail || "Failed to fetch user data");
            }
            const data = await response.json();
            setTodayLeads(data);
        } catch (error) {
            console.error("Error fetching today's leads data:", error);
        } finally {
            setTodayLeadsLoading(false);
        }
    };

    const fetchDateRangeLeads = async (startDate: any, endDate: any) => {
        setDateRangeLeadsLoading(true);
        try {
            const response = await fetch(
                `${webApi}/dashboard/employee_calling_conversation_dashboard/?from_date=${startDate}&to_date=${endDate}`,
                options
            );
            const data = await response.json();
            setDateRangeLeads(data);
        } catch (error) {
            console.error("Error fetching date range leads:", error);
        } finally {
            setDateRangeLeadsLoading(false);
        }
    };

    useEffect(() => {
        if (!checkPermission("can_view_employee_dashboard", "Records")) {
            navigate(routes.crmLandingPage);
        } else {
            fetchData();
            fetchMonitoringStatusDropdown();
            fetchTodayLeadsData();
            fetchDateRangeLeads(startDate, endDate);
            // fetchLeaderboard("today");
            // fetchCalldDailyGraph();
            // fetchSalesGraph();
            // fetchSalesVsConnected();
            // fetchSalesVsCallBacks();
            // fetchSalesvsIntrested();
            // fetchTop3();
            // fetchOverall();
            // fetchGroupsCard(GroupsstartDate, GroupsendDate);
            // fetchSalesRank();
            // fetchBranches();
            // fetchClassWizeSales();
        }
    }, [userPermissions]);

    const data1 = [
        { name: "Mon", Calls: 80, Connected: 40 },
        { name: "Tue", Calls: 120, Connected: 90 },
        { name: "Wed", Calls: 100, Connected: 60 },
        { name: "Thu", Calls: 130, Connected: 85 },
        { name: "Fri", Calls: 90, Connected: 50 },
        { name: "Sat", Calls: 110, Connected: 80 },
    ];

    const [showCalendar, setShowCalendar] = useState(false);
    const [showCalendar1, setShowCalendar1] = useState(false);
    const [dateRange, setDateRange] = useState(() => {
        const savedDates = localStorage.getItem("dateRange");
        if (savedDates) {
            const parsed = JSON.parse(savedDates);
            return parsed.map((range: any) => ({
                ...range,
                startDate: range.startDate ? new Date(range.startDate) : null,
                endDate: range.endDate ? new Date(range.endDate) : null,
            }));
        }
        // ✅ Start with null values
        return [
            {
                startDate: null,
                endDate: null,
                key: "selection",
            },
        ];
    });

    useEffect(() => {
        localStorage.setItem("dateRange", JSON.stringify(dateRange));
    }, [dateRange]);

    useEffect(() => {
        if (dateRange[0].startDate === null && dateRange[0].endDate === null) {
            handleFetchResetDateRangeLEads();
        }
    }, [dateRange]);



    const startDate =
        dateRange?.[0]?.startDate instanceof Date && !isNaN(dateRange[0].startDate)
            ? format(dateRange[0].startDate, "yyyy-MM-dd")
            : "";

    const endDate =
        dateRange?.[0]?.endDate instanceof Date && !isNaN(dateRange[0].endDate)
            ? format(dateRange[0].endDate, "yyyy-MM-dd")
            : "";


    const [groupsdateRange, setGroupsDateRange] = useState(() => {
        const savedDates = localStorage.getItem("GroupsdateRange");
        if (savedDates) {
            const parsed = JSON.parse(savedDates);
            return parsed.map((range: any) => ({
                ...range,
                GroupsstartDate: range.GroupsstartDate ? new Date(range.GroupsstartDate) : null,
                GroupsendDate: range.GroupsendDate ? new Date(range.GroupsendDate) : null,
            }));
        }
        // ✅ Start with null values
        return [
            {
                GroupsstartDate: null,
                GroupsendDate: null,
                key: "selection",
            },
        ];
    });

    useEffect(() => {
        localStorage.setItem("GroupsdateRange", JSON.stringify(groupsdateRange));
    }, [groupsdateRange]);

    useEffect(() => {
        if (groupsdateRange[0].GroupsstartDate === null && groupsdateRange[0].GroupsendDate === null) {
            handleFetchResetGroupsData();
        }
    }, [groupsdateRange]);



    const GroupsstartDate =
        groupsdateRange?.[0]?.GroupsstartDate instanceof Date && !isNaN(groupsdateRange[0].GroupsstartDate)
            ? format(groupsdateRange[0].GroupsstartDate, "yyyy-MM-dd")
            : "";

    const GroupsendDate =
        groupsdateRange?.[0]?.GroupsendDate instanceof Date && !isNaN(groupsdateRange[0].GroupsendDate)
            ? format(groupsdateRange[0].GroupsendDate, "yyyy-MM-dd")
            : "";

    const handleFetchDateRangeLEads = () => {
        setShowCalendar1(false);
        fetchDateRangeLeads(startDate, endDate);
    };

    const handleFetchResetDateRangeLEads = () => {
        setShowCalendar1(false);
        fetchDateRangeLeads("", "");
    };

    const handleFetchGroupsData = () => {
        setShowCalendar(false);
        fetchGroupsCard(GroupsstartDate, GroupsendDate);
    };

    const handleFetchResetGroupsData = () => {
        setShowCalendar(false);
        fetchGroupsCard("", "");
    };

    const [selectedAgents, setSelectedAgents] = useState<number[]>([]);
    const [selectedStatus, setSelectedStatus] = useState<any>("");
    const handleCheckboxChange = (agentId: any) => {
        setSelectedAgents((prevSelected) => {
            if (prevSelected.includes(agentId)) {
                return prevSelected.filter((id) => id !== agentId);
            } else {
                return [...prevSelected, agentId];
            }
        });
    };

    const handleStatusChange = async (value: any) => {
        const statusId = value;
        setSelectedStatus(statusId);

        if (selectedAgents.length > 0 && statusId) {
            const payload = {
                user_ids: selectedAgents,
            };

            try {
                const response = await fetch(
                    `${webApi}/user_monitoring/change_multiple_agents_status/${statusId}/`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${jwtToken}`,
                        },
                        body: JSON.stringify(payload),
                    }
                );

                if (response.ok) {
                    console.log("Status updated successfully");
                    setIsStatusChange(true);
                    setSelectedAgents([]);
                    setSelectedStatus("");
                    fetchData();
                } else {
                    console.error("Failed to update status");
                }
            } catch (error) {
                console.error("Error:", error);
            }
        }
    };


    const winRate = 7.802; // Example Win Rate (0-10%)
    const growth = 0.5; // Example Growth (+ or -)

    // Radial Bar Chart Data (Segments)
    const data2 = [
        { value: 2, fill: "#FDCFE2" }, // Light Pink
        { value: 3, fill: "#F48FB1" }, // Medium Pink
        { value: 5, fill: "#D32D7E" }, // Dark Pink
    ];

    // Convert winRate (0-10%) to an angle (180° to 0°)
    const needleAngle1 = (winRate / 10) * 180 - 180;

    const data3 = [
        { day: "Mon", sales: 95 },
        { day: "Tue", sales: 130 },
        { day: "Wed", sales: 85 },
        { day: "Thu", sales: 120 },
        { day: "Fri", sales: 75 },
        { day: "Sat", sales: 110 },
        { day: "Sun", sales: 140 },
    ];

    const sampleData = [{ value: 7.802 }];
    const sampleGrowth = 0.5;

    const data = [{ value: winRate }];
    const needleAngle = 180 - (winRate / 10) * 180;

    const containerStyle = {
        position: "fixed" as "fixed",
        bottom: "10px",
        right: "10px",
        display: "flex",
        flexDirection: "column" as "column",
        gap: "10px",
        backgroundColor: "rgba(255, 255, 255, 0.8)", // Optional: Add background for better visibility
        borderRadius: "8px", // Optional: Rounded corners
        padding: "10px", // Optional: Add some padding
    };

    const [isOpen, setIsOpen] = useState(false);

    const toggleCard = () => {
        setIsOpen(!isOpen);

        const offcanvasEl = document.getElementById("offcanvasRight");
        if (offcanvasEl) { // ✅ Fix 2
            const bsOffcanvas = Offcanvas.getOrCreateInstance(offcanvasEl);
            isOpen ? bsOffcanvas.hide() : bsOffcanvas.show();
        }
    };

    useEffect(() => {
        document.body.style.overflow = isOpen ? "hidden" : "auto";
    }, [isOpen]);

    useEffect(() => {
        const offcanvasEl = document.getElementById("offcanvasRight");

        const handleShow = () => setIsOpen(true);
        const handleHide = () => setIsOpen(false);

        if (offcanvasEl) {
            offcanvasEl.addEventListener("show.bs.offcanvas", handleShow);
            offcanvasEl.addEventListener("hide.bs.offcanvas", handleHide);
        }

        return () => {
            if (offcanvasEl) {
                offcanvasEl.removeEventListener("show.bs.offcanvas", handleShow);
                offcanvasEl.removeEventListener("hide.bs.offcanvas", handleHide);
            }
        };
    }, []);



    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    <>
                        {/* Page Header */}
                        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                            <div className="my-auto mb-2">
                                <h3 className="page-title mb-1">Employee Dashboard</h3>
                                <nav>
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item">
                                            <Link to={routes.adminDashboard}>Dashboard</Link>
                                        </li>
                                        <li
                                            className="breadcrumb-item active"
                                            aria-current="page"
                                        >
                                            Admin Dashboard
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                        <div className="row">
                            {photoLoading ? (
                                <div
                                    style={{
                                        height: "100%",
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <LogoSpinnerInline />
                                </div>
                            ) : (
                                <div className="col-md-12 d-flex">
                                    <div
                                        className="card flex-fill"
                                        style={{
                                            background: bgGradient,
                                            border: "none",
                                            transition: "background 0.4s ease",
                                        }}
                                    >
                                        <div className="card-body" style={{ position: "relative" }}>
                                            <h1 className="text-white mb-1">
                                                Welcome {userData?.username.toLowerCase()}
                                            </h1>
                                            <p className="text-white mb-3">Have a Good day at work</p>

                                            <div
                                                style={{
                                                    position: "absolute",
                                                    right: 0,
                                                    top: 0,
                                                    height: "100%",
                                                    aspectRatio: "56 / 56", // ✅ force 1:1
                                                    // minWidth: "150px",
                                                    maxWidth: "45%",
                                                    overflow: "hidden",
                                                    pointerEvents: "none",
                                                }}
                                            >
                                                <img
                                                    src={photo1}
                                                    alt="User Profile"
                                                    crossOrigin="anonymous"
                                                    onLoad={(e) => extractColor(e.currentTarget)}
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        objectFit: "cover",

                                                        /* clarity */
                                                        filter: "brightness(1.08) contrast(1.15) saturate(1.15)",

                                                        /* smooth blend */
                                                        WebkitMaskImage:
                                                            "linear-gradient(to left, rgba(0,0,0,1), rgba(0,0,0,0.7))",
                                                        maskImage:
                                                            "linear-gradient(to left, rgba(0,0,0,1), rgba(0,0,0,0))",
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="row">
                            {DateRangeLeadsLoading ? (
                                <div
                                    style={{
                                        height: "100%",
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <LogoSpinnerInline />
                                </div>
                            ) : (
                                // tod.map((card, index) => (
                                <>
                                    <div
                                        // key={card.id}
                                        className="col-xxl-3 col-sm-6 d-flex"
                                    >
                                        <motion.div
                                            className="card flex-fill animate-card border-0"
                                            variants={cardVariants}
                                            initial="hidden"
                                            animate="visible"
                                            // custom={index}
                                            whileHover={{
                                                y: -6,
                                                scale: 1.02,
                                                boxShadow: "0px 10px 25px rgba(0,0,0,0.12)",
                                            }}
                                        >
                                            <div className="card-body">
                                                {/* Top section */}
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar avatar-xl me-2 p-1">
                                                        <ImageWithBasePath
                                                            src="/assets/img/logo.png"
                                                        // alt={card.heading}
                                                        />
                                                    </div>

                                                    <div className="overflow-hidden flex-fill">
                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <h2 className="counter">
                                                                <CountUp end={Number(dateRangeLeads?.total_calls)} />
                                                            </h2>

                                                            <span
                                                                className={`badge ${Number(dateRangeLeads?.call_connected_per) < 25
                                                                    ? "bg-danger"
                                                                    : Number(dateRangeLeads?.call_connected_per) < 50
                                                                        ? "bg-warning"
                                                                        : Number(dateRangeLeads?.call_connected_per) < 75
                                                                            ? "bg-primary"
                                                                            : "bg-success"
                                                                    }`}
                                                            >
                                                                {dateRangeLeads?.call_connected_per}%
                                                            </span>
                                                        </div>

                                                        <p>{"calls"}</p>
                                                    </div>
                                                </div>

                                                {/* Bottom section */}
                                                <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                                                    <p className="mb-0">
                                                        {"Connected Calls"} :{" "}
                                                        <span className="text-dark fw-semibold">
                                                            {dateRangeLeads?.connected_calls}
                                                        </span>
                                                    </p>

                                                    <span className="text-light">|</span>

                                                    {/* <p className="mb-0">
                                                    {"Missed Calls"} :{" "}
                                                    <span className="text-dark fw-semibold">
                                                        {todayLeads?.total_calls - todayLeads?.connected_calls}
                                                    </span>
                                                </p> */}
                                                </div>
                                            </div>
                                        </motion.div>
                                    </div>
                                    <div
                                        // key={card.id}
                                        className="col-xxl-3 col-sm-6 d-flex"
                                    >
                                        <motion.div
                                            className="card flex-fill animate-card border-0"
                                            variants={cardVariants}
                                            initial="hidden"
                                            animate="visible"
                                            // custom={index}
                                            whileHover={{
                                                y: -6,
                                                scale: 1.02,
                                                boxShadow: "0px 10px 25px rgba(0,0,0,0.12)",
                                            }}
                                        >
                                            <div className="card-body">
                                                {/* Top section */}
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar avatar-xl me-2 p-1">
                                                        <ImageWithBasePath
                                                            src="/assets/img/logo.png"
                                                        // alt={card.heading}
                                                        />
                                                    </div>

                                                    <div className="overflow-hidden flex-fill">
                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <h2 className="counter">
                                                                <CountUp end={Number(dateRangeLeads?.unique_leads_touch)} />
                                                            </h2>

                                                            <span
                                                                className={`badge ${Number(dateRangeLeads?.unique_leads_connected_per) < 25
                                                                    ? "bg-danger"
                                                                    : Number(dateRangeLeads?.unique_leads_connected_per) < 50
                                                                        ? "bg-warning"
                                                                        : Number(dateRangeLeads?.unique_leads_connected_per) < 75
                                                                            ? "bg-primary"
                                                                            : "bg-success"
                                                                    }`}
                                                            >
                                                                {dateRangeLeads?.unique_leads_connected_per}%
                                                            </span>
                                                        </div>

                                                        <p>{"unique leads"}</p>
                                                    </div>
                                                </div>

                                                {/* Bottom section */}
                                                <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                                                    <p className="mb-0">
                                                        {"Connected Unique Leads"} :{" "}
                                                        <span className="text-dark fw-semibold">
                                                            {dateRangeLeads?.unique_leads_connected}
                                                        </span>
                                                    </p>

                                                    <span className="text-light">|</span>

                                                    {/* <p className="mb-0">
                                                    {"Missed Calls"} :{" "}
                                                    <span className="text-dark fw-semibold">
                                                        {todayLeads?.total_calls - todayLeads?.connected_calls}
                                                    </span>
                                                </p> */}
                                                </div>
                                            </div>
                                        </motion.div>
                                    </div>
                                </>
                            )}
                            <div className="row">


                                <div className="col-xxl-12 col-xl-12 d-flex">
                                    <div className="card flex-fill">
                                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                                            <h4 className="card-title mb-3">Agent Activity</h4>
                                            <div className="d-flex align-items-center me-3 mb-3">
                                                <Select
                                                    showSearch
                                                    allowClear
                                                    placeholder="Select Status"
                                                    value={selectedStatus}
                                                    onChange={handleStatusChange}
                                                    disabled={selectedAgents.length === 0}
                                                    style={{ width: 150, borderTopColor: '#fff', borderLeftColor: '#fff', borderRightColor: '#fff' }}
                                                    optionFilterProp="label"
                                                    filterOption={(input, option) =>
                                                        (option?.label ?? "")
                                                            .toLowerCase()
                                                            .includes(input.toLowerCase())
                                                    }
                                                    options={monitoringStatus.map(group => ({
                                                        value: group.id,
                                                        label: group.name,
                                                    }))}
                                                />
                                                <BiRefresh
                                                    className={`refresh-icon ${refreshIsLoading ? "spin" : ""} ms-3`}
                                                    onClick={fetchData}
                                                />
                                            </div>
                                        </div>
                                        {refreshIsLoading ? (
                                            <div
                                                style={{
                                                    height: "100%",
                                                    width: "100%",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <LogoSpinnerInline />
                                            </div>
                                        ) : (
                                            <div className="card-body px-0">
                                                <div
                                                    className="custom-datatable-filter table-responsive"
                                                    style={{ maxHeight: "480px", overflowY: "auto" }} // scroll here
                                                >
                                                    <table className="table table-hover mb-0">
                                                        <thead className="thead-light" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                                                            <tr>
                                                                <th>Action</th>
                                                                <th>Agent Name</th>
                                                                <th>Status</th>
                                                                <th>Session Duration</th>
                                                                <th>Calls</th>
                                                                <th>Connected</th>
                                                                <th>Idle Time</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {dashboardData?.map((agent) => (
                                                                <tr key={agent.id} style={{ height: "48px" }}>
                                                                    <td>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedAgents.includes(agent.id)}
                                                                            onChange={() => handleCheckboxChange(agent.id)}
                                                                            disabled={
                                                                                agent.status_name === "Offline" ||
                                                                                agent.status_name === "On Call"
                                                                            }
                                                                        />
                                                                    </td>

                                                                    <td><div className="d-flex align-items-center">
                                                                        <div className="avatar avatar-md">
                                                                            <ImageWithBasePath
                                                                                src={
                                                                                    "/assets/img/logo.png"
                                                                                }
                                                                                className="img-fluid rounded-circle"
                                                                                alt="img"
                                                                            />
                                                                        </div><div className="ms-2"><p className="text-dark mb-0">{agent.agent_name}</p></div></div></td>
                                                                    <td>
                                                                        {(() => {
                                                                            let badgeClass = "badge bg-secondary";

                                                                            if (agent.status_name === "Available") {
                                                                                badgeClass = "badge bg-success";
                                                                            } else if (agent.status_name === "Offline") {
                                                                                badgeClass = "badge bg-danger";
                                                                            } else if (agent.status_name === "Work Assign") {
                                                                                badgeClass = "badge bg-info";
                                                                            }

                                                                            return (
                                                                                <>
                                                                                    <span>
                                                                                        <i className={`${badgeClass} ti ti-circle-filled fs-9`} />
                                                                                    </span>
                                                                                    <span>{agent.status_name}</span>
                                                                                </>
                                                                            );
                                                                        })()}
                                                                    </td>

                                                                    <td>
                                                                        <Counter updatedAt={agent.updated_at} />
                                                                    </td>
                                                                    <td>{agent.calls}</td>
                                                                    <td>{agent.connected}</td>
                                                                    <td>
                                                                        {(() => {
                                                                            const [h = 0, m = 0, s = 0] = agent.total_ideal_time
                                                                                .split(":")
                                                                                .map(Number);

                                                                            const seconds = h * 3600 + m * 60 + s;

                                                                            let badgeClass = "badge bg-danger";

                                                                            if (seconds <= 300) {
                                                                                badgeClass = "badge bg-success";
                                                                            } else if (seconds <= 900) {
                                                                                badgeClass = "badge bg-warning";
                                                                            }

                                                                            return (
                                                                                <>
                                                                                    <span>{agent.total_ideal_time}</span>{" "}
                                                                                </>
                                                                            );
                                                                        })()}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>


                            </div>
                        </div>
                    </>
                </div>
            </div>


            {/* Modal */}
            <AdminDashboardModal />

            {/* CSS Styles */}
        </>
    );
};

export default EmployeeDashboard;
